import {UI, registerStyle, Theme} from "../../../stem-core/src/ui/UI";

import {styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {MerchantLoadingSpinnerStyle} from "./MerchantLoadingSpinner";
import {BlinkLogoSpinner, LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";


class WalletLoadingSpinnerStyle extends MerchantLoadingSpinnerStyle {
    @styleRuleInherit
    loadingSpinner = {
        ">:last-child g": {
            fill: this.themeProps.WALLET_SPINNER_LOGO,
        },
        background: this.themeProps.WALLET_SPINNER_BACKGROUND,
    };
}

@registerStyle(WalletLoadingSpinnerStyle)
export class WalletLoadingSpinner extends LoadingSpinner {
    render() {
        return <BlinkLogoSpinner size={48} strokeWidth={3} radius={20} strokeColor={Theme.props.WALLET_SPINNER_COLOR}/>;
    }
}
